import { render } from "./ContractFields.vue?vue&type=template&id=5dac0d8e"
import script from "./ContractFields.vue?vue&type=script&lang=js"
export * from "./ContractFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__